import axios from 'axios';

import contextTypes from 'bundles/email/context_types';
import { take } from 'lodash';

function getDesignOverridePath(pathTemplate, designOverride) {
  const path = pathTemplate.replace(':designId', designOverride.designId);
  return designOverride.id ? `${path}/${designOverride.id}` : path;
}

export default class OptionDefaultsApi {
  constructor(designOverridePathTemplate, previewPath) {
    this.designOverridePathTemplate = designOverridePathTemplate;
    this.previewPath = previewPath;
  }

  saveDesignOverride(designOverride) {
    const path = getDesignOverridePath(this.designOverridePathTemplate, designOverride);

    return axios[designOverride.id ? 'put' : 'post'](path, {
      design_override: {
        option_defaults: designOverride.optionDefaults
      }
    });
  }

  deleteDesignOverride(designOverride) {
    const path = getDesignOverridePath(this.designOverridePathTemplate, designOverride);
    return axios.delete(path);
  }

  getPreview(design, optionValues, property, properties, brokers) {
    const params = {
      design_id: design.id,
      options: optionValues
    };

    if (design.contextType === contextTypes.propertyEmail) {
      params.property_id = property.id;
    } else if (design.contextType === contextTypes.multiPropertyEmail) {
      params.property_ids = properties.map(property => property.id);
    } else if (design.contextType === contextTypes.spaceNeedsEmail) {
      params.broker_ids = take(brokers, 3).map(broker => broker.id);
    }

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    return axios.get(this.previewPath, { signal: this.abortController.signal, params });
  }
}
